import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    zIndex: theme.zIndex.dialog + 1,
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
  },
  rootAnimation: {
    position: "fixed",
    top: "200%",
    animation: "$dailyRewardUp ease-in-out 1s 5.5s forwards",
  },
  list: {
    color: theme.colors.text2,
    fontSize: 14,
    textAlign: "left",
    lineHeight: "25px",
  },
  gridContent: {
    gap: `${theme.spacing.space12}px ${theme.spacing.space8}px`,
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  },
  content: {
    gap: theme.spacing.space12,
    display: "grid",
  },
  title: {
    gap: theme.spacing.space4,
    display: "grid",
  },
  activeCard: {
    width: "50%",
    height: 240,
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  button: {
    animation: "$appendAnimate 1s linear forwards",
    transformOrigin: "50% 0",
  },
  buttonAnimation: {
    animation:
      "$appendAnimate ease-out 0.5s forwards, $appendBackGround ease-out 0.5s forwards",
    transformOrigin: "50% 0",
    height: 0,
    borderWidth: "0 !important",
    overflow: "hidden",
    padding: 0,
    background: "rgba(255, 255, 255, 0.15)",
    bottom: -theme.spacing.space12,
  },

  "@keyframes dailyRewardUp": {
    "0%": {
      top: "200%",
    },
    "100%": {
      top: "0%",
    },
  },
  "@keyframes appendAnimate": {
    "0%": {
      height: 0,
      transform: "scaleY(0)",
    },
    "100%": {
      height: 44,
      transform: "scaleY(1)",
    },
  },
  "@keyframes appendBackGround": {
    "0%": {
      background: "rgba(255, 255, 255, 0.15)",
      color: "#6A6A6A",
    },
    "90%": {
      background: "rgba(255, 255, 255, 0.15)",
      color: "#6A6A6A",
    },
    "100%": {
      background: theme.colors.primary,
      color: "#fff",
    },
  },
}));
